module.exports = __webpack_public_path__ + "img/accueil.121d23fe.png";